import axios from 'axios'

axios.defaults.headers['Content-type'] = 'application/json;charset=UTF-8'
const request = axios.create({
  baseURL: process.env.VUE_APP_BASEURL,
  timeout:  30000,
})

export default request